import styled from 'styled-components';
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
// import { useWishlist } from '../../context/WishlistContext.js';
import ModalCartao from '../../components/ModalCartao.js'; //Modal
import ModalEndereco from '../../components/ModalEndereco.js'; //Modal
import { useLocation } from 'react-router-dom';
import fundo from '../assets/fundo.jpg'
import avatar from '../assets/avatar2.png'

import {
    ContainerPerfil,
    BoxConta,
    BannerPerfil,
    BoxAddFoto,
    ButtonAddFoto,
    P1, P2, P3, P4, P5, P6, P7, P8, P9, P10, P11, P12, P13,
    P14, P15, P16, P17, P18, P19, P20, P21, P22, P23, P24,
    P25, P26, P27,
    ContainerFotosUsuario,
    ContainerInfoUsuario,
    FotoUsuario,
    InfoUsuario,
    InfoUsuarioMargin,
    ContainerNavPerfil,
    BoxNavPerfil,
    DivNavPerfil,
    DivNavPerfilMobile,
    DivNavPerfilPrincip,
    NavMobile,
    BoxMinhaConta,
    InfoMinhaConta,
    BoxInfoMinhaConta,
    BoxInformacoes,
    ContainerFlex,
    BoxCheckbox,
    BoxAdd,
    BoxInfoMinhaContaMobile,
    BoxNavPerfilMobile,
    InputBoxNavMobile,
    DivBoxnav,
    BoxnavSeta,
    PerfilNavMobile,
    SetaBaixoNav,

    // Meus cartoes

    BoxMinhaCarteira,
    InfoMinhaCarteira,
    BoxInfoMinhaCarteira,
    BoxInfoMinhaCarteiraFlex,
    CardCartao,
    BoxInfoCartao,
    BoxInfoCartaoAtivo,
    CardBandeira,

    // Meus enderecos

    BoxMeusEnderecos,
    InfoMeusEnderecos,
    BoxInfoMeusEnderecos,
    BoxInfoMeusEnderecosFlex,
    CardEndereco,
    BoxInfoEndereco,
    BoxInfoEnderecoAtivo,
    BoxEnderecoAtivoFlex,
    BoxEnderecoAtivoFlex2,
    EnderecoAtivoFlex,
    BoxFlexInfoAtivo,
    BoxEnderecoEditar,
    BoxEnderecoExcluir,

    // Meus Pedidos

    BoxMeusPedidos,
    InfoMeusPedidos,
    BoxInfoMeusPedidos,
    BoxInfoMeusPedidosFlex,
    DivPesquisa,
    InputPesquisa,
    BoxInfoPedidos,
    NavInfoPedidos,
    CardPedidos,
    CardPedidosAtivo,
    BoxInfoPedidos2,
    CardNavPedidos,
    BoxInfoNavPedidos,
    BoxFlexPedido,
    BoxPedidoItem,

    //Minha lista de desejos

    BoxMinhaListaDesejos,
    InfoMeusDesejos,
    InfoMeusDesejosFlex,
    CardListDesejos,
    CardAddDesejos,
    BoxAddDesejo,
    AddItemLista,

    //Produto

    BoxProduto,
    InfoProduto,
} from '../../components/PerfilPage.style.js';
import {
    NomeProdutoP,
    PReviews,
    ValorNovoP
} from '../../components/Product.style.js';
import Camera from '../../components/svg/camera.svg';
import CameraCircle from '../../components/svg/cameraCircle.svg';
import SetaMobileBaixo from '../../components/svg/setamobilebaixo.svg';
import AdcionarCartao from '../../components/svg/adcionarCartao.svg';
import LupaPesquisa from '../../components/svg/pesquisa.svg';
import Sacola2 from '../../components/svg/sacola2.svg';
import CoracaoDesejo from '../../components/svg/desejo.svg';
import Estrela from '../../components/svg/estrelinhaProduto.svg';

import VisaCard from '../../components/assets/VisaCard.png';
import apiService from '../../api/home.js';
import axios from 'axios';



function Perfil({ DadosAPI }) {

    //Navegacao lista de pordutos

    const navigate = useNavigate();

    // const { wishlist } = useWishlist();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [shopVisivel, setShopVisivel] = useState(false);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');

    const toggleShop = () => setShopVisivel(!shopVisivel);

    const handleNavClick = (section) => {
        setActiveSection(section);
        setShopVisivel(false); // Fecha o menu ao clicar em um item
    };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const location = useLocation();
    const { state } = location;
    // const [activeSection, setActiveSection] = useState('Minha conta');
    const [activeSection, setActiveSection] = useState('Meus pedidos');

    useEffect(() => {
        pegarDados()
    }, []);

    useEffect(() => {
        verificarLogado()
    }, []);

    const verificarLogado = async () => {

        var get_idusuario = await localStorage.getItem('@idusuario')

        if (get_idusuario == null || get_idusuario == '') {
            navigate('/account')
            return false
        }
        

        //verifica se ele veio do checkout
        var _voltar_checkout = localStorage.getItem('_voltar_checkout');
        if(_voltar_checkout && _voltar_checkout == 's'){
            navigate('/checkout')
        }
       
    }


    const pegarDados = async () => {

        var get_email = await localStorage.getItem("@email");
        var get_nome = await localStorage.getItem("@nome");
        setNome(get_nome)
        setEmail(get_email)

    }

    useEffect(() => {
        if (state?.activeSection) {
            setActiveSection(state.activeSection);
        }
    }, [state]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const clickSair = async () => {
        localStorage.clear()
        navigate('/account');
    }

    //   const text = windowWidth <= 425 ? 'Editar' : 'Editar foto de capa';

    // Componente acordeon
    const [expandedCard, setExpandedCard] = useState(null);

    const handleToggleExpand = (index) => {
        if (expandedCard === index) {
            setExpandedCard(null); // Se já está expandido, colapsa
        } else {
            setExpandedCard(index); // Expande o cartão clicado
        }
    };

    // Lista de pedidos de exemplo
    const pedidos = [
        {
            data: '27 de Mai. de 2024',
            numero: '#6546462',
            status: 'Pago',
            total: 'R$156,00',
            itens: [
                { nome: 'Nome produto 1', quantidade: 1, preco: 'R$ 0,00' },
                { nome: 'Nome produto 2', quantidade: 1, preco: 'R$ 0,00' },
                { nome: 'Nome produto 3', quantidade: 1, preco: 'R$ 0,00' },
            ],
        },
        // Adicione mais pedidos aqui conforme necessário
        {
            data: '27 de Mai. de 2024',
            numero: '#6546462',
            status: 'Pago',
            total: 'R$156,00',
            itens: [
                { nome: 'Nome produto 1', quantidade: 1, preco: 'R$ 0,00' },
                { nome: 'Nome produto 2', quantidade: 1, preco: 'R$ 0,00' },
                { nome: 'Nome produto 3', quantidade: 1, preco: 'R$ 0,00' },
            ],
        },
        // Adicione mais pedidos aqui conforme necessário
        {
            data: '27 de Mai. de 2024',
            numero: '#6546462',
            status: 'Pago',
            total: 'R$156,00',
            itens: [
                { nome: 'Nome produto 1', quantidade: 1, preco: 'R$ 0,00' },
                { nome: 'Nome produto 2', quantidade: 1, preco: 'R$ 0,00' },
                { nome: 'Nome produto 3', quantidade: 1, preco: 'R$ 0,00' },
            ],
        },

    ];

    useEffect(() => {
        listarVendas();
    }, [])

    const [vendasAPI, setVendasAPI] = useState([])
    const getAmbiente = apiService.ambiente();

    const listarVendas = async () => {

        var idusuario = await localStorage.getItem('@idusuario')

        var getDominio = apiService.obterDominio()


        try {
            const response = await axios.post(
                getAmbiente + '/integracao/venda/listar',
                {
                    idusuario: idusuario,
                    dominio: getDominio
                }
            );

            console.log('Dados recebidos vendas:', response.data.retorno);

            setVendasAPI(response.data.retorno)
        } catch (error) {
            console.error('Erro ao listar vendas:', error);
        }
    };

    const formatCurrency = (value) => {
        // Verifica se o valor é nulo ou indefinido
        if (value == null) {
            return 'R$ 0,00'; // Retorna um valor padrão
        }

        // Converte o valor em uma string, remove caracteres não numéricos e tenta convertê-lo em um número
        const numericValue = parseFloat(String(value).replace(/[^\d.-]/g, ''));

        // Verifica se o valor é um número válido
        if (!isNaN(numericValue)) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numericValue);
        } else {
            // Retorna o valor original se não for um número válido
            return String(value);
        }
    };

    function formatarData(dataISO) {
        const data = new Date(dataISO);

        // Obtém o dia, mês e ano
        const dia = data.getDate().toString().padStart(2, '0');
        const meses = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
        const mes = meses[data.getMonth()];
        const ano = data.getFullYear();

        // Formata a data no estilo desejado
        return `${dia} de ${mes} de ${ano}`;
    }

    function verMais(item) {
        // Converte o número para string e depois para Base64
        const idvenda = btoa(item.idvenda);
        const idempresa = btoa(item.idempresa);

        // Gera o link com os parâmetros em Base64
        const url = `${getAmbiente}/checkout.php?idvenda=${idvenda}&idempresa=${idempresa}`;

        // Abre a URL em uma nova janela
        window.open(url, '_blank');
    }

    const renderSection = () => {
        switch (activeSection) {
            // case 'Minha conta':
            //     return (
            //         <BoxMinhaConta>
            //             <P5>Minha conta</P5>
            //             <InfoMinhaConta>
            //                 <BoxInfoMinhaConta>
            //                     <BoxInformacoes>
            //                         <P6>Seu nome</P6>
            //                         <div><P7>Rubens Schueng Netto</P7></div>
            //                     </BoxInformacoes>
            //                     <BoxInformacoes>
            //                         <P6>Seu e-mail</P6>
            //                         <div><P7>ne**********@gmail.com</P7></div>
            //                     </BoxInformacoes>
            //                     <BoxInformacoes>
            //                         <P6>Seu número de celular</P6>
            //                         <BoxAdd><P7>+ clique para adicionar</P7></BoxAdd>
            //                     </BoxInformacoes>
            //                     <BoxInformacoes>
            //                         <P6>Sexo</P6>
            //                         <ContainerFlex>
            //                             <BoxCheckbox>
            //                                 <input type="checkbox" id="item1"/>
            //                                 <P7 style={{fontSize:12}}>Masculino</P7>
            //                             </BoxCheckbox>
            //                             <BoxCheckbox>
            //                                 <input type="checkbox" id="item1"/>
            //                                 <P7 style={{fontSize:12}}>Masculino</P7>
            //                             </BoxCheckbox>
            //                             <BoxCheckbox>
            //                                 <input type="checkbox" id="item1"/>
            //                                 <P7 style={{fontSize:12}}>Masculino</P7>
            //                             </BoxCheckbox>
            //                         </ContainerFlex>
            //                     </BoxInformacoes>
            //                     <BoxInformacoes>
            //                         <P6>Seu CPF</P6>
            //                         <BoxAdd><P7>+ clique para adicionar</P7></BoxAdd>
            //                     </BoxInformacoes>
            //                 </BoxInfoMinhaConta>
            //                 <BoxInfoMinhaConta>
            //                     <BoxInformacoes>
            //                         <P6>Data de nascimento</P6>
            //                         <BoxAdd><P7>+ clique para adicionar</P7></BoxAdd>
            //                     </BoxInformacoes>
            //                 </BoxInfoMinhaConta>
            //                 <BoxInfoMinhaContaMobile>
            //                     <BoxInformacoes>
            //                         <P6>Fale um pouco sobre você:</P6>
            //                         <BoxAdd><P7>+ clique para adicionar biografia</P7></BoxAdd>
            //                     </BoxInformacoes>
            //                 </BoxInfoMinhaContaMobile>
            //             </InfoMinhaConta>
            //         </BoxMinhaConta>
            //     );
            // case 'Minha carteira':
            //     return (
            //         <BoxMinhaCarteira>
            //             <InfoMinhaCarteira>
            //                 <BoxInfoMinhaCarteira>
            //                     <P5>Minha carteira</P5>
            //                     <P9>Salve as informações do cartão de crédito para o seu próximo checkout ser mais rápido.</P9>
            //                 </BoxInfoMinhaCarteira>
            //                 <BoxInfoMinhaCarteiraFlex>
            //                     <CardCartao>
            //                         <BoxInfoCartaoAtivo>
            //                             <div>
            //                                 <CardBandeira><img style={{width: 23.545, height: 14}} src={VisaCard}/></CardBandeira>
            //                             </div>
            //                             <div>
            //                                 <P14>1234 1234 1234 1234</P14>
            //                                 <P15>05/34</P15>
            //                             </div>
            //                             <div>
            //                                 <P16>RUBENS S NETTO</P16>
            //                             </div>
            //                         </BoxInfoCartaoAtivo>
            //                     </CardCartao>

            //                     <CardCartao onClick={openModal}>
            //                         <BoxInfoCartao>
            //                             <img src={AdcionarCartao} alt="Adicionar Cartão"/>
            //                             <P10>Você ainda não salvou <br/> nenhum cartão</P10>
            //                             <P11 style={{ margin: 0 }}>Clique para adicionar</P11>
            //                         </BoxInfoCartao>
            //                     </CardCartao>

            //                     <ModalCartao isOpen={isModalOpen} onClose={closeModal} />
            //                 </BoxInfoMinhaCarteiraFlex>
            //                 <BoxInfoMinhaCarteira>
            //                     <P9>Faça uma compra em nosso site e não vai mais precisar <br/>
            //                     digitar todos os dados novamente do seu cartão.</P9>
            //                 </BoxInfoMinhaCarteira>
            //             </InfoMinhaCarteira>
            //         </BoxMinhaCarteira>
            //     );
            // case 'Meus endereços':
            //     return (
            //         <BoxMeusEnderecos>
            //             <InfoMeusEnderecos>
            //                 <BoxInfoMeusEnderecos>
            //                     <P5>Meus endereços</P5>
            //                     <P9>Adicione e gerencie os endereços que você usa com frequência.</P9>
            //                 </BoxInfoMeusEnderecos>
            //                 <BoxInfoMeusEnderecosFlex>
            //                     <CardEndereco>
            //                         <BoxInfoEnderecoAtivo>
            //                             <BoxEnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex><P17>Rubens Schueng Netto</P17></EnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxEnderecoEditar><P18>Editar</P18></BoxEnderecoEditar>
            //                                     <BoxEnderecoExcluir><P18>Excluir</P18></BoxEnderecoExcluir>
            //                                 </EnderecoAtivoFlex>
            //                             </BoxEnderecoAtivoFlex>
            //                             <BoxEnderecoAtivoFlex2>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P19>Nome destinatário:</P19>
            //                                     </BoxFlexInfoAtivo>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P20>Rubens Schueng Netto</P20>
            //                                     </BoxFlexInfoAtivo>
            //                                 </EnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P19>Endereço:</P19>
            //                                     </BoxFlexInfoAtivo>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P20>Rua Abiail Amaral Carneiro, 85</P20>
            //                                     </BoxFlexInfoAtivo>
            //                                 </EnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P19>Bairro:</P19>
            //                                     </BoxFlexInfoAtivo>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P20>Enseada do Suá</P20>
            //                                     </BoxFlexInfoAtivo>
            //                                 </EnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P19>Cidade / UF:</P19>
            //                                     </BoxFlexInfoAtivo>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P20>Vitória / ES</P20>
            //                                     </BoxFlexInfoAtivo>
            //                                 </EnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P19>CEP:</P19>
            //                                     </BoxFlexInfoAtivo>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P20>29050-535</P20>
            //                                     </BoxFlexInfoAtivo>
            //                                 </EnderecoAtivoFlex>
            //                                 <EnderecoAtivoFlex>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P19>Complemento:</P19>
            //                                     </BoxFlexInfoAtivo>
            //                                     <BoxFlexInfoAtivo>
            //                                         <P20>Apto 1501 - Torre 1</P20>
            //                                     </BoxFlexInfoAtivo>
            //                                 </EnderecoAtivoFlex>
            //                             </BoxEnderecoAtivoFlex2>
            //                         </BoxInfoEnderecoAtivo>
            //                     </CardEndereco>

            //                     <CardEndereco onClick={openModal}>
            //                         <BoxInfoEndereco>
            //                             <img src={AdcionarCartao} alt="Adicionar Endereco"/>
            //                             <P10>Clique para adicionar <br/>
            //                             um endereço</P10>
            //                             <P11 style={{margin:0}}>Clique para adicionar</P11>
            //                         </BoxInfoEndereco>
            //                     </CardEndereco>

            //                     <ModalEndereco isOpen={isModalOpen} onClose={closeModal} />
            //                 </BoxInfoMeusEnderecosFlex>
            //             </InfoMeusEnderecos>
            //         </BoxMeusEnderecos>
            //     );
            case 'Meus pedidos':
                return (
                    <BoxMeusPedidos>
                        <InfoMeusPedidos>
                            <BoxInfoMeusPedidos>
                                <div>
                                    <P5 style={{ marginBottom: 5 }}>Meus pedidos</P5>
                                    <P9 style={{ margin: 0 }}>
                                        Visualize seu histórico de pedidos ou verifique <br />
                                        o status de um pedido recente.
                                    </P9>
                                </div>
                                {/* <div>
                                    <DivPesquisa>
                                        <InputPesquisa placeholder="Pesquisar" />
                                        <img src={LupaPesquisa} alt="Pesquisar" />
                                    </DivPesquisa>
                                </div> */}
                            </BoxInfoMeusPedidos>
                            <BoxInfoMeusPedidosFlex>
                                <BoxInfoPedidos>
                                    <NavInfoPedidos>
                                        <BoxInfoNavPedidos>
                                            <P24>Data</P24>
                                        </BoxInfoNavPedidos>
                                        <BoxInfoNavPedidos>
                                            <P24>Pedido</P24>
                                        </BoxInfoNavPedidos>
                                        <BoxInfoNavPedidos>
                                            <P24>Status</P24>
                                        </BoxInfoNavPedidos>
                                        <BoxInfoNavPedidos>
                                            <P24>Total</P24>
                                        </BoxInfoNavPedidos>
                                    </NavInfoPedidos>
                                </BoxInfoPedidos>
                                {/* Lista de pedidos */}
                                {vendasAPI?.map((pedido, index) => (
                                    // {pedidos.map((pedido, index) => (
                                    <CardPedidosAtivo key={index}>
                                        <CardNavPedidos>
                                            <BoxInfoNavPedidos>
                                                <P21>{formatarData(pedido.datapagamento ? pedido.datapagamento : pedido.data)}</P21>
                                            </BoxInfoNavPedidos>
                                            <BoxInfoNavPedidos>
                                                <P21>#{pedido.idpedido}</P21>
                                            </BoxInfoNavPedidos>
                                            <BoxInfoNavPedidos>
                                                <P22
                                                    style={{
                                                        color: pedido.pedidostatus == 'Pedido Criado' ? '#007bff' :
                                                            pedido.pedidostatus == 'Pedido Aguardando Pagamento' ? '#ffc107' :
                                                                pedido.pedidostatus == 'Pedido Pago' ? '#28a745' :
                                                                    pedido.pedidostatus == 'Pedido Cancelado' ? '#dc3545' :
                                                                        pedido.pedidostatus == 'Pedido Faturado' ? '#17a2b8' :
                                                                            pedido.pedidostatus == 'Pedido Entregue' ? '#447850' :
                                                                                '#000000'
                                                    }}
                                                >{pedido.pedidostatus}</P22>
                                            </BoxInfoNavPedidos>
                                            <BoxInfoNavPedidos>
                                                <P21>{formatCurrency(pedido.total)}</P21>
                                            </BoxInfoNavPedidos>
                                            <BoxInfoNavPedidos>
                                                <P23 style={{ cursor: 'pointer' }} onClick={() => verMais(pedido)}>
                                                    Ver detalhes
                                                </P23>
                                            </BoxInfoNavPedidos>
                                        </CardNavPedidos>
                                        {/* Detalhes do pedido */}
                                        {/* {expandedCard === index && (
                                            <CardNavPedidos style={{ gap: 50 }}>
                                                {pedido.itens.map((item, idx) => (
                                                    <BoxFlexPedido key={idx}>
                                                        <BoxPedidoItem>
                                                            <div style={{ width: 60, height: 60, borderRadius: 10, background: '#D2D2D2' }}></div>
                                                        </BoxPedidoItem>
                                                        <BoxPedidoItem>
                                                            <P25>{item.nome}</P25>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                                <P26>{item.quantidade} X</P26>
                                                                <P27>{item.preco}</P27>
                                                            </div>
                                                        </BoxPedidoItem>
                                                    </BoxFlexPedido>
                                                ))}
                                            </CardNavPedidos>
                                        )} */}
                                    </CardPedidosAtivo>
                                ))}
                            </BoxInfoMeusPedidosFlex>
                        </InfoMeusPedidos>
                    </BoxMeusPedidos>
                );
            // case 'Minha lista de desejos':
            //     return (
            //         <BoxMinhaListaDesejos>
            //             <InfoMeusDesejos>
            //                 <P5 style={{marginBottom:5}}>Minha lista de desejos</P5>
            //                 <P9 style={{margin:0}}>Veja os produtos favoritos que você salvou na sua lista de desejos.</P9>
            //             </InfoMeusDesejos>
            //             <InfoMeusDesejosFlex>
            //                 <CardListDesejos>
            //                     {wishlist.length === 0 ? (
            //                         <AddItemLista>
            //                             <Link style={{ textDecoration: 'none' }} to="/product">
            //                                 <CardAddDesejos>
            //                                     <BoxAddDesejo><img src={CoracaoDesejo} /></BoxAddDesejo>
            //                                     <BoxAddDesejo>
            //                                         <P12>Você ainda não tem nenhum <br/>
            //                                             produto na sua lista de desejos</P12>
            //                                         <P13>Clique aqui para ir para o shop</P13>
            //                                     </BoxAddDesejo>
            //                                 </CardAddDesejos>
            //                             </Link>
            //                         </AddItemLista>
            //                     ) : (
            //                         wishlist.map((product) => (
            //                             <div key={product.id}>
            //                                 <Link style={{ textDecoration: 'none', color: 'black' }} to={`/product/${product.id}`}>
            //                                     <BoxProduto>
            //                                         <div style={{ width: 310, height: 309, borderRadius: 20, background: '#F5F5F5' }}>
            //                                             <img src={product.image} alt={product.name} />
            //                                         </div>
            //                                         <InfoProduto>
            //                                             <div><NomeProdutoP style={{ margin: 0, marginBottom: 5 }}>{product.name}</NomeProdutoP></div>
            //                                             <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            //                                                 <div style={{ display: 'flex', gap: 3, alignItems: 'center' }}>
            //                                                     <img src={Estrela} alt="Estrela" />
            //                                                     <PReviews style={{ margin: 0 }}>{product.rating}</PReviews>
            //                                                 </div>
            //                                                 <div>
            //                                                     <PReviews style={{ margin: 0 }}>{product.reviews} reviews</PReviews>
            //                                                 </div>
            //                                             </div>
            //                                             <div><ValorNovoP style={{ margin: 0 }}>{product.price}</ValorNovoP></div>
            //                                         </InfoProduto>
            //                                     </BoxProduto>
            //                                 </Link>
            //                             </div>
            //                         ))
            //                     )}
            //                 </CardListDesejos>
            //             </InfoMeusDesejosFlex>
            //         </BoxMinhaListaDesejos>
            //     );
            default:
                return <BoxMinhaConta />;
        }
    };

    return (
        <ContainerPerfil>
            <BoxConta>
                <ContainerFotosUsuario>
                    <BannerPerfil>
                        {/* <BoxAddFoto>
                                <ButtonAddFoto>
                                    <img src={Camera}/>
                                    <P1>{text}</P1>
                                </ButtonAddFoto>
                            </BoxAddFoto> */}
                        <img style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }} src={fundo} />
                    </BannerPerfil>
                    <ContainerInfoUsuario>
                        <FotoUsuario>
                            <img style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }} src={avatar} />
                            {/* <img style={{margin:5.53, cursor:'pointer'}} src={CameraCircle}/> */}
                        </FotoUsuario>
                        <InfoUsuario>
                            <InfoUsuarioMargin>
                                <P2>{nome}</P2>
                                <P3>{email}</P3>
                                <P3 style={{ marginTop: 3, fontSize: 8, cursor: 'pointer' }} onClick={() => { clickSair() }}>Sair</P3>
                            </InfoUsuarioMargin>
                        </InfoUsuario>
                    </ContainerInfoUsuario>
                </ContainerFotosUsuario>
                <ContainerNavPerfil>
                    <BoxNavPerfil>
                        {/* <DivNavPerfil 
                                isActive={activeSection === 'Minha conta'}
                                onClick={() => setActiveSection('Minha conta')}
                            >
                                <P4>Minha conta</P4>
                            </DivNavPerfil>
                            <DivNavPerfil 
                                isActive={activeSection === 'Minha carteira'}
                                onClick={() => setActiveSection('Minha carteira')}
                            >
                                <P4>Minha carteira</P4>
                            </DivNavPerfil>
                            <DivNavPerfil 
                                isActive={activeSection === 'Meus endereços'}
                                onClick={() => setActiveSection('Meus endereços')}
                            >
                                <P4>Meus endereços</P4>
                            </DivNavPerfil> */}
                        <DivNavPerfil
                            isActive={activeSection === 'Meus pedidos'}
                            onClick={() => setActiveSection('Meus pedidos')}
                        >
                            <P4>Meus pedidos</P4>
                        </DivNavPerfil>
                        {/* <DivNavPerfil 
                                isActive={activeSection === 'Minha lista de desejos'}
                                onClick={() => setActiveSection('Minha lista de desejos')}
                            >
                                <P4>Minha lista de desejos</P4>
                            </DivNavPerfil> */}
                    </BoxNavPerfil>
                    <BoxNavPerfilMobile>
                        <InputBoxNavMobile onClick={toggleShop}>
                            <DivBoxnav><P8>{activeSection}</P8></DivBoxnav>
                            <BoxnavSeta><SetaBaixoNav visivel={shopVisivel}><img src={SetaMobileBaixo} /></SetaBaixoNav></BoxnavSeta>
                        </InputBoxNavMobile>
                        <PerfilNavMobile visivel={shopVisivel}>
                            <NavMobile>
                                {/* <DivNavPerfilMobile isActive={activeSection === 'Minha conta'}
                                    onClick={() => handleNavClick('Minha conta')}>
                                        <P4>Minha conta</P4>
                                    </DivNavPerfilMobile>
                                    <DivNavPerfilMobile isActive={activeSection === 'Minha carteira'}
                                    onClick={() => handleNavClick('Minha carteira')}>
                                        <P4>Minha carteira</P4>
                                    </DivNavPerfilMobile>
                                    <DivNavPerfilMobile isActive={activeSection === 'Meus endereços'}
                                    onClick={() => handleNavClick('Meus endereços')}>
                                        <P4>Meus endereços</P4>
                                    </DivNavPerfilMobile> */}
                                <DivNavPerfilMobile isActive={activeSection === 'Meus pedidos'}
                                    onClick={() => handleNavClick('Meus pedidos')}>
                                    <P4>Meus pedidos</P4>
                                </DivNavPerfilMobile>
                                {/* <DivNavPerfilMobile isActive={activeSection === 'Minha lista de desejos'}
                                    onClick={() => handleNavClick('Minha lista de desejos')}>
                                        <P4>Minha lista de desejos</P4>
                                    </DivNavPerfilMobile> */}
                            </NavMobile>
                        </PerfilNavMobile>
                    </BoxNavPerfilMobile>
                </ContainerNavPerfil>
                {vendasAPI ? renderSection() :
                    <BoxMinhaConta>
                        Não encontramos nenhum pedido no momento
                    </BoxMinhaConta>
                }
            </BoxConta>
        </ContainerPerfil>
    );
}

export default Perfil;